import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import EtiquetaMacroscopiaPage from './etiqueta.page';
import * as actions from '../../macroscopia.action';
import WebapiCommon from '../../../../../../app/common/util/webapi.common';
import { acessoPermitido } from '../../../../../../acessos.seguranca';

class EtiquetaMacroscopiaContainer extends Component {
  constructor() {
    super();
    this.state = {
      selecionados: [],
      all: false,
    };
  }

  render() {
    return (
      <EtiquetaMacroscopiaPage
        usuario={this.props.usuario}
        detalhes={this.props.detalhes}
        blocos={this.props.blocosExistentes}
        onClick={this.onClick.bind(this)}
        onClickAll={this.onClickAll.bind(this)}
        all={this.state.all}
        selecionados={this.state.selecionados}
        loading={this.loading.bind(this)}
        acessoPermitido={acessoPermitido}
      />
    );
  }

  componentDidMount() {
    WebapiCommon.getBlocos(this.props.detalhes.laudo).then((blocos) => {
      this.props.actions.adicionarBlocosExistentes(blocos);
      this.selecionarTodasEtiquetas();
    });
  }

  onClickAll() {
    if (!this.state.all) {
      this.selecionarTodasEtiquetas();
    } else {
      this.setState({
        all: false,
        selecionados: [],
      });
    }
  }

  selecionarTodasEtiquetas() {
    let _selecionados = [];
    for (let i = 0; i < this.props.blocosExistentes.length; i++) {
      const bloco = this.props.blocosExistentes[i];
      _selecionados.push(bloco.id);
    }
    this.setState({
      all: true,
      selecionados: _selecionados,
    });
  }

  onClick(id) {
    const index = this.state.selecionados.indexOf(id);
    let _selecionados = [...this.state.selecionados];

    if (index === -1) {
      _selecionados.push(id);
    } else {
      _selecionados.splice(index, 1);
    }

    this.setState({
      selecionados: _selecionados,
    });
  }

  loading(show) {
    this.props.actions.showFadeCarregando(show);
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario,
    detalhes: state.commonReducer.detalhes,
    blocosExistentes: state.macroscopia.blocosExistentes,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EtiquetaMacroscopiaContainer);



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/macroscopia/operacoes/etiqueta/etiqueta.container.js